module.exports = __webpack_public_path__ + "img/ArrowDown.2a3cf33e.svg";